import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/Crm/overviews'

export default {
  namespaced: true,
  state: {
    loading: false,
    overviews: {
      complaints: {
        sales: 0,
        services: 0,
        rentals: 0,
        secondHands: 0,
      },
      chartData: {
        series: [],
        labels: [],
      },
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    overviews(state) {
      return state.overviews
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_OVERVIEWS(state, data) {
      state.overviews = data
    },
    /* RESET MUTATIONS */
    RESET_OVERVIEWS(state) {
      state.overviews = {
        complaints: {
          sales: 0,
          services: 0,
          rentals: 0,
          secondHands: 0,
        },
        chartData: {
          series: [],
          labels: [],
        },
      }
    },
  },
  actions: {
    getData({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_OVERVIEWS')
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_OVERVIEWS', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
